import React from 'react'
import NextBoxDiaryHeader from './NextBoxDiaryTable/NextBoxDiaryHeader'
import NextBoxDiaryRow from './NextBoxDiaryTable/NextBoxDiaryRow'
import { Empty } from 'antd'

function NextBoxDiaryTable(props) {
    const { listData = [], reset, selectedAll, listSelecteds, handleChangeSelectAll, handleSelected } = { ...props }

    return (
        <div className='NextBoxDiaryTable'>
            <table className="table table-striped">
                <NextBoxDiaryHeader
                    handleChangeSelectAll={handleChangeSelectAll}
                    selectedAll={selectedAll}
                    listSelecteds={listSelecteds}
                />
                <tbody className='NextBoxDiaryRow'>
                    {listData.length > 0 ?
                        listData.map((i, index) => (
                            <NextBoxDiaryRow
                                key={`NextBoxDiaryRow_${index}`}
                                item={i}
                                index={index}
                                listSelecteds={listSelecteds}
                                handleSelected={handleSelected}
                                reset={reset}
                            />
                        )) :
                        <tr>
                            <td colSpan={4}>
                                <Empty description='Không có dữ liệu' />
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default NextBoxDiaryTable